/**
 * `<Chip>` + `<Kbd>` — small mono pills.
 *
 *   Chip neutral  → source labels, mode names ("hybrid", "joplin").
 *   Chip soft     → tinted with primary for "active" status indicators.
 *   Kbd           → small monospace pill for keyboard hints.
 */

import type { HTMLAttributes, ReactNode } from 'react';

interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  /** `neutral` (default) or `soft` (primary-tinted). */
  variant?: 'neutral' | 'soft';
  children: ReactNode;
}

export function Chip({ variant = 'neutral', className = '', children, ...rest }: ChipProps): JSX.Element {
  const cn = ['chip', variant === 'soft' ? 'chip-soft' : '', className].filter(Boolean).join(' ');
  return (
    <span className={cn} {...rest}>
      {children}
    </span>
  );
}

interface KbdProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

export function Kbd({ className = '', children, ...rest }: KbdProps): JSX.Element {
  return (
    <span className={`kbd ${className}`.trim()} {...rest}>
      {children}
    </span>
  );
}
